import React, {useEffect} from 'react';
import { useParams, useNavigate } from "react-router-dom";
import usePageTitle from 'hooks/usePageTitle';
import useGetCompleteForm from 'services/formsBuilder/useGetCompleteForm';
import useGetSurveyJson from 'services/surveys/useGetSurveyJson';
import useGetSurveyJsonBySurvey from 'services/surveys/useGetSurveyJsonBySurvey';
import PageMenu from 'components/blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../img/icons/svg/botones/flecha-big-gris.svg";
import SurveyForm from "components/blocks/Forms/SurveyForm/SurveyForm";
import { TextMessagesTemplates } from 'components/blocks/TextMessagesTemplates/TextMessagesTemplates';
import LoaderMin from 'components/blocks/Loader/LoaderMin';


const SurveyDetail:React.FC = (props:any) => {
  const navigate = useNavigate();
  usePageTitle('Detalle de Encuesta');
  const { surveyId } = useParams<{ surveyId: string }>();
  const {
    getCompleteForm,
    formData,
    loading,
    error } = useGetCompleteForm();
  
  const {
    getSurveyJsonBySurvey,
  } = useGetSurveyJsonBySurvey();

  useEffect(()=> {
    getCompleteForm(surveyId)
    getSurveyJsonBySurvey(surveyId);
  }, [])

  if(loading) {
    return(
      <section>
        {TextMessagesTemplates.loading}
      </section>
    )
  }
  if(error) {
    return(
      <section>
        {TextMessagesTemplates.errorResponse}
      </section>
    )
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <PageMenu
              title={"Encuesta"}
              breadcrumbs={["Mis encuestas","Encuesta"]}
            >
              <div className="btns-header-container">
                <button onClick={()=>navigate(-1)}>
                  <img src={IconArrowGray} alt="icon arrow right" />
                </button>
              </div>
            </PageMenu>
          </div>
        </div>
        <section className="container">
          <div className="row">
            <div className="col-12">
              {/* <SurveyForm
                {...props}
                surveyData={surveyJson}
              /> */}
              {formData && !loading?               
                <SurveyForm
                  {...props}
                  surveyData={formData}
                />
                :
                <>
                  {loading &&
                    <LoaderMin/>
                  }
                  {error &&
                    <p className="loader-text">Lo sentimos, se ha producido un error.</p>
                  }
                </>
              }
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default SurveyDetail;